// Exam utility functions

export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const calculateScore = (examData, answers) => {
  let correct = 0;
  let total = 0;
  
  examData.forEach(passage => {
    passage.questions.forEach(q => {
      total++;
      // Handle both 'correct' and 'correctAnswer' properties
      const correctAnswerIndex = q.correct ?? q.correctAnswer;
      if (answers[q.id] === correctAnswerIndex) correct++;
    });
  });
  
  return { correct, total };
};

export const getScoreGrade = (correct, total) => {
  const percentage = (correct / total) * 100;
  
  if (percentage >= 84) return { grade: 'Excellent', color: 'green' };
  if (percentage >= 68) return { grade: 'Good', color: 'blue' };
  if (percentage >= 52) return { grade: 'Fair', color: 'yellow' };
  return { grade: 'Needs Improvement', color: 'red' };
};


export const getTotalQuestions = (examData, sectionId = null) => {
  console.log('getTotalQuestions called with sectionId:', sectionId);
  
  const result = examData.reduce((total, passage) => {
    if (sectionId === 'situational-judgment') {
      console.log('Processing SitJud passage:', passage.id);
      // For SitJud, count total responses across all scenarios
      const passageTotal = passage.questions.reduce((sum, q) => {
        const responsesCount = q.responses ? q.responses.length : 1;
        console.log('Question has', responsesCount, 'responses');
        return sum + responsesCount;
      }, 0);
      console.log('Passage total:', passageTotal);
      return total + passageTotal;
    } else {
      // For other sections, just count questions
      return total + passage.questions.length;
    }
  }, 0);
  
  console.log('Final total:', result);
  return result;
};